<style scoped>
.status-labels {
    position: absolute;
    -webkit-transform: translate(0, -100%);
    transform: translate(0, -100%);
    @apply flex;
    @apply text-xs;

    & .status-label {
        @apply flex-shrink-0;
        @apply ml-1;
        @apply px-2 py-1;
    }
}

.status-label.status-label-new {
    background-color: #ffff00;
    color: #0070c0;
}

.status-label.status-label-hot {
    background-color: #ff0000;
    color: white;
}

.product-brand {
    font-size: 1rem;
    line-height: 1.5;
    /* min-height: calc(1.5 * 0.875rem); */
    font-weight: bold;
}

.product-name {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    font-size: 0.875rem;
    line-height: 1.5;
    /* min-height: calc(2 * 1.5 * 0.75rem); */
    @apply text-darkGrayishBlue;
}

.product-size,
.product-reference-price {
    font-size: 0.75rem;
    line-height: 1.5;
    /* min-height: calc(1.5 * 0.625rem); */
}

.product-reminder {
    font-size: 0.75rem;
    line-height: 1.5;
    /* min-height: calc(1.5 * 0.625rem); */
}

.product-qty-msg {
    font-size: 1rem;
    line-height: 1.5;
    min-height: calc(1.5 * 0.875rem);
    @apply text-red font-semibold;
}
.product-qty-msg .tooltip {
    position: relative;
    display: inline-block;
}

/* Tooltip text */
.product-qty-msg .tooltip .tooltiptext {
    font-size: 0.5rem;
    visibility: hidden;
    width: 100px;
    color: black;
    background-color: #fff2cc;
    border-color: #ffbf00;
    border-width: 1px;
    text-align: center;
    padding: 5px 0;

    position: absolute;
    top: -10px;
    z-index: 1;
    left: 110%;

    @apply font-normal;
}

.product-qty-msg .tooltip:hover .tooltiptext {
    visibility: visible;
}
</style>

<template>
    <component
        :is="componentWrapper"
        class="flex flex-col text-lg px-4 py-8 relative"
        :class="[productWidthClass]"
    >
        <div
            v-if="!isShoppingListOpen"
            class="absolute z-10 w-1/4 bg-red text-white text-sm text-center"
        >
            快閃已結束
        </div>
        <div v-if="!!isShoppingListOpen" class="status-labels">
            <div v-if="isNewProduct" class="status-label status-label-new">
                新上架
            </div>
            <div v-if="isHotProduct" class="status-label status-label-hot">
                熱賣中
            </div>
        </div>
        <div
            class="flex flex-col border rounded-sm flex-grow border-gray-100 p-3"
        >
            <router-link :to="productDetailRoute" @click.native="productClick">
                <productImage imageType="small" :product="product" />
                <hr class="my-4 border-gray-100" />
                <div class="product-brand">
                    {{ product.prodBrndName || '&emsp;' }}
                </div>
                <contentNewLine
                    v-if="$config.showProdName"
                    class="product-name"
                    :value="product.prodName"
                />
                <div class="product-size">
                    {{ product.prodSizeText }}
                </div>
                <div class="product-reminder">
                    {{ product.prodSaleRmdrText }}
                </div>
            </router-link>
            <div class="mt-auto">
                <div
                    class="product-qty-msg"
                    v-if="
                        product.prodUnitPrcAmt !== undefined &&
                            product.prodUnitPrcAmt !== null
                    "
                >
                    <template v-if="productActualRemainingQty <= 0">
                        <template
                            v-if="
                                product.pgsProdSaleQtyInd === 'Y' &&
                                    product.rmnProdQty >
                                        productActualRemainingQty
                            "
                        >
                            <div class="tooltip">
                                {{ $t('product.pgs.zero.qty') }}
                                <span class="tooltiptext">
                                    {{ $t('product.pgs.zero.qty.tooltip') }}
                                </span>
                            </div>
                        </template>
                        <template v-else>
                            {{ $t('product.zero.qty') }}
                        </template>
                    </template>
                    <template
                        v-else-if="
                            product.warnProdQty &&
                                product.warnProdQty >= productActualRemainingQty
                        "
                    >
                        {{
                            $t('product.last.items', productActualRemainingQty)
                        }}
                    </template>
                    <template v-else-if="product.pgsProdSaleQtyInd === 'Y'">
                        <div style="color: orange">
                            {{ $t('product.pgs.sale') }}
                        </div>
                    </template>
                </div>

                <div class="product-reference-price">
                    <template v-if="product.prodRefPrcAmt">
                        {{ saleCatgRefPrcName }}
                        {{ product.prodRefPrcAmt | price }}
                    </template>
                </div>
                <div class="flex items-center">
                    <div
                        class="font-extrabold text-sm"
                        :class="{
                            'text-red': isLessThanOrigPrcAmt,
                            'text-darkGrayishBlue': !isLessThanOrigPrcAmt
                        }"
                    >
                        {{ saleCatgUnitPrcName }}
                        <span
                            :class="{
                                'text-red': product.prodUnitPrcAmt === 0
                            }"
                        >
                            {{ product.prodUnitPrcAmt | price(true) }}
                        </span>
                    </div>
                    <div
                        class="ml-auto text-sm text-gray-300 font-bold line-through"
                        v-if="isLessThanOrigPrcAmt"
                    >
                        {{ product.prodOrigUnitPrcAmt | price }}
                    </div>
                </div>
            </div>
        </div>
        <buttonAddToCart
            class="bg-secondary block mx-auto mt-2"
            :disabled="
                productActualRemainingQty <= 0 ||
                    !isShoppingListOpen ||
                    product.prodUnitPrcAmt === undefined ||
                    product.prodUnitPrcAmt === null
            "
            :product="product"
        />
        <productQuickViewModalButton
            v-if="false"
            class="flex justify-center"
            :product="product"
        />
        <div class="h-16 hidden">
            <buttonProdSmplMap
                v-if="getSmplProdMapResultProd"
                :targetProduct="getSmplProdMapResultProd"
                class="w-full mt-4"
            />
        </div>
    </component>
</template>

<script>
import buttonAddToCart from '@/components/buttonAddToCart.vue';
import buttonProdSmplMap from '@/components/buttonProdSmplMap.vue';
import price from '@/components/priceFilter';
import productImage from '@/components/productImage.vue';
import ribbon from '@/components/ribbon.vue';
import contentNewLine from '@/components/contentNewLine';
import intersectionContainer from '../components/intersectionContainer.vue';
import { marketingEventHandler } from '../utils/marketingDataProcessor.js';
import productQuickViewModalButton from '@/components/productQuickViewModalButton';

const intersectionContainerWrapper = () => ({
    name: 'intersectionContainerWrapper',
    render(h) {
        return h(
            intersectionContainer,
            {
                props: {
                    mode: 'interval',
                    targetIntersectionRatio: 0.5,
                    cooldownMilliSecond: 60 * 1000
                },
                on: {
                    changeToVisible: () => {
                        marketingEventHandler.productDisplay(
                            this.$parent.product.prodKey,
                            this.$parent.product.shopListKey
                        );
                    }
                }
            },
            this.$slots.default
        );
    }
});

export default {
    components: {
        buttonAddToCart,
        buttonProdSmplMap,
        productImage,
        ribbon,
        contentNewLine,
        intersectionContainer,
        productQuickViewModalButton
    },
    filters: { price },
    props: {
        product: { required: true },
        productWidthClass: { default: 'w-1/2 lg:w-1/3 ' },
        componentWrapper: { default: () => intersectionContainerWrapper() },
        productClickAction: {
            type: Function,
            default: vm => {
                marketingEventHandler.productClick(
                    vm.product.prodKey,
                    vm.product.shopListKey
                );
            }
        }
    },
    computed: {
        isLessThanOrigPrcAmt() {
            return this.$store.getters.isLessThanOrigPrcAmt(this.product);
        },
        getSmplProdMapResultProd() {
            return this.$store.getters.getSmplProdMapResult(this.product);
        },
        previewCmpyToken() {
            return this.$store.getters.previewCmpyToken;
        },
        isShoppingListOpen() {
            return this.$store.getters.isShoppingListOpen;
        },
        productActualRemainingQty() {
            return this.$store.getters.productActualRemainingQty(this.product);
        },
        productDetailRoute() {
            return this.$store.getters.productDetailRoute(this.product.id);
        },
        isNewProduct() {
            return this.product.newProdInd === 'Y';
        },
        isHotProduct() {
            return this.product.hotProdInd === 'Y';
        },
        saleCatgRefPrcName() {
            return (
                this.product.custRefPrcName ||
                this.$store.getters.saleCatgRefPrcName(this.product)
            );
        },
        saleCatgUnitPrcName() {
            return (
                this.product.custUnitPrcName ||
                this.$store.getters.saleCatgUnitPrcName(this.product)
            );
        }
    },
    methods: {
        productClick() {
            this.productClickAction(this);
        }
    }
};
</script>
